/* global angular */

angular.module('gc.ui.smartEditPopup', [])
.directive('smartEditPopup', [
'$log',
'$window',
'CommentService',
function ($log, $window, CommentService) {
  'use strict';
  return {
    restrict: 'AE',
    templateUrl: 'smartEditPopup.html',
    replace: true,
    scope: {
      smedControl: '='
    },
    link: function ($scope, $element) {
      var popupEl = $element;
      var popupInfo = {
        popupWidth: popupEl[0].clientWidth
      };
      var iControl = $scope.smedControl || {};
      var savedSel = null;
      iControl.popupEl = popupEl;
      iControl.callbacks = {};

      // sometimes, due to the display:none, element width = 0.
      if (popupInfo.popupWidth === 0) {
        popupInfo.popupWidth = 164; // fallback width
      }

      popupEl.on('mouseup', function (event) {
        event.stopPropagation();
      });

      $scope.linkInterface = false;
      $scope.CommentService = CommentService;

      /**
       * Show the popup and place it for the arrow point to point (x, y)
       * @param x {number} The easting value from the left
       * @param y {number} The northing value from the top
       */
      iControl.show = function (x, y) {
        $scope.linkInterface = false;

        var cssModifier = {display: 'block'};

        popupInfo.x = x;
        popupInfo.y = y;

        cssModifier.left = (popupInfo.x - (popupInfo.popupWidth / 2));
        cssModifier.top = (popupInfo.y - 50);
        cssModifier.width = popupInfo.popupWidth;

        setPopupCoordinate(cssModifier);

        if (!$scope.$$phase) {
          $scope.$apply();
        }
      };

      /**
       * Close the popup
       */
      iControl.close = function () {
        popupEl.css({display: 'none'});
        $scope.linkChosen = '';
        $scope.linkInterface = false;
      };

      /**
       * @param e {object} The event
       * @param options {object} The options
       * @param options.action {string} The type of action
       * @param options.callbacks {object} The functions which are called when modifier is clicked
       */
      function eventRecieved(e, options) {
        //$log.debug('smedPopup -> ', options);

        if (options.action === 'open') {
          iControl.options = options;
          if (options.callbacks) {
            iControl.callbacks = options.callbacks;
          }
          iControl.show(options.coordinates.x, options.coordinates.y);
        } else if (options.action === 'close') {
          iControl.close();
        }
      }

      function saveSelection() {
        if (window.getSelection) {
          var sel = window.getSelection();
          if (sel.getRangeAt && sel.rangeCount) {
            var ranges = [];
            for (var i = 0, len = sel.rangeCount; i < len; ++i) {
              ranges.push(sel.getRangeAt(i));
            }
            return ranges;
          }
        } else if (document.selection && document.selection.createRange) {
          return document.selection.createRange();
        }
        return null;
      }

      function restoreSelection(savedSel) {
        if (savedSel) {
          if (window.getSelection) {
            var sel = window.getSelection();
            sel.removeAllRanges();
            for (var i = 0, len = savedSel.length; i < len; ++i) {
              sel.addRange(savedSel[i]);
            }
          } else if (document.selection && savedSel.select) {
            savedSel.select();
          }
        }
      }

      function changeArrowOffset(sizeInPx) {
        $scope.arrowOffset = (sizeInPx - 5) + 'px';
      }

      /**
       * Apply options to the Popup and make sure it fit in screen
       * @param options
       */
      function setPopupCoordinate(options) {

        var margin = 5;

        if (options.left < margin) {
          changeArrowOffset(options.left + margin);
          options.left = margin;
        }
        else if ((options.left + options.width) > ($window.innerWidth - margin)) {
          changeArrowOffset(options.left + options.width - $window.innerWidth - margin);
          options.left = $window.innerWidth - options.width - margin;
        }
        else {
          changeArrowOffset(0);
        }

        // Fix position (when not in an iframe)
        options.top += window.scrollY || window.pageYOffset || document.body.scrollTop;

        var cssModifier = {
          left: options.left + 'px',
          top: options.top + 'px'
        };

        if (options.display) {
          cssModifier.display = options.display;
        }

        popupEl.css(cssModifier);
      }

      $scope.$on('smedPopup', eventRecieved);

      /**
       * Do action following the click of popup modifier
       * @param modifier {string} The string identifying the modifier clicking
       */
      $scope.selectModifier = function (event, modifier) {
        event.preventDefault();
        switch (modifier) {
          case 'bold':
            if (iControl.callbacks.bold) {
              iControl.callbacks.bold(iControl);
            }
            break;
          case 'italic':
            if (iControl.callbacks.italic) {
              iControl.callbacks.italic(iControl);
            }
            break;
          case 'underline':
            if (iControl.callbacks.underline) {
              iControl.callbacks.underline(iControl);
            }
            break;
          case 'code':
            if (iControl.callbacks.code) {
              iControl.callbacks.code(iControl);
            }
            break;
          case 'link':
            savedSel = saveSelection();
            $scope.changeToLink();
            break;
          default:
            console.error('select modifier unknown');
        }
      };

      $scope.changeToLink = function () {

        var coordinate = {
          left: (popupInfo.x - (225 / 2)),
          top: (popupInfo.y - 50),
          width: 225
        };

        setPopupCoordinate(coordinate);

        $scope.linkInterface = true;
        $scope.linkChosen = '';
      };

      $scope.changeToMenu = function () {

        var coordinate = {
          left: (popupInfo.x - (popupInfo.popupWidth / 2)),
          top: (popupInfo.y - 50),
          width: popupInfo.popupWidth
        };

        setPopupCoordinate(coordinate);

        $scope.linkInterface = false;
      };

      $scope.linkWithUrl = function () {
        if (savedSel && $scope.linkChosen) {
          restoreSelection(savedSel);
          if (iControl.callbacks.link) {
            iControl.callbacks.link(iControl, $scope.linkChosen);
          }
        }
      };
    }
  };
}]);
